<template>
  <div class="page-wrapper">
    <commonHeader heading="学习力数据管理" subtitle="现行指标数据管理" addTitle="新增学习力指标" @callback="addClick()">
      <template v-slot:icon>
        <span class="iconfont icon-fanhui back" @click="goBack()"></span>
      </template>
    </commonHeader>
    <div class="table-data">
      <v-card>
        <div class="table-header">
          <v-text-field class="text-field-width" v-model="queryParams.value1" placeholder="指标名称" hide-details solo
            clearable></v-text-field>
          <v-text-field class="text-field-width" v-model="queryParams.value2" placeholder="创建人" hide-details solo
            clearable></v-text-field>

          <v-select class="select-width" 
            v-model="queryParams.value3" 
            :items="zyTypeList" 
            item-text="name" 
            item-value="type" 
            label="指标类型"
            color="#4caf50"
            hide-details solo
          ></v-select>

          <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field class="date-width" v-model="queryParams.date" hide-details solo readonly
                placeholder="创建时间" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="zh-cn" v-model="queryParams.date" @input="dateMenu = false"></v-date-picker>
          </v-menu>
          <v-btn depressed color="primary" @click="searchQuery">
            搜索
          </v-btn>
          <v-btn depressed @click="searchClear">
            清空
          </v-btn>
        </div>
        <div class="table-content">
          <v-data-table
            no-data-text="暂无数据"
            hide-default-footer 
            :headers="tableHeader" 
            :items="tableList" 
            :items-per-page="5"
          >
            <template #[`item.name`]="{ item }">
              <a
                style="color: #9c27b0; cursor: pointer"
                >{{ item.name }}</a
              >
            </template>
            <template #[`item.type`]="{ item }">
              {{ zyTypeDict[item.type] }}
            </template>
            <template #[`item.option`]="{ item }">
              <v-btn
                icon
                color="primary"
                small
              >
                <span class="mdi mdi-cancel" style="font-size: 20px;"></span>
                <md-tooltip md-direction="top">禁止</md-tooltip>
              </v-btn>
              <v-btn
                icon
                color="primary"
                small
              >
                <span class="mdi mdi-square-edit-outline" style="font-size: 20px;"></span>
                <md-tooltip md-direction="top">编辑</md-tooltip>
              </v-btn>
              <v-btn
                icon
                color="error"
                small
              >
                <span class="mdi mdi-trash-can-outline" style="font-size: 20px;"></span>
                <md-tooltip md-direction="top">删除</md-tooltip>
              </v-btn> 
            </template>
          </v-data-table>
        </div>
        <div class="table-paging">
          <v-pagination 
            class="table-pagination" 
            prev-icon="fa fa-angle-left" 
            next-icon="fa fa-angle-right"
            color="#4caf50"
            circle 
            :value="pagination.page" 
            :length="pagination.total"
            :total-visible="7"
            @input="inputChange"
          ></v-pagination>
        </div>
      </v-card>
    </div>

    <v-dialog v-model="dialog" max-width="800px" @input="inputDialog">
      <v-card class="card-shadow">
        <v-form ref="formRef" v-model="formValid">         
          <v-card-title>
            <span class="text-h5">新增</span>
          </v-card-title>
          <v-card-text class="card-padding">
            <v-text-field v-model="formData.name" label="指标名称 *" color="#4caf50"
              :rules="[(v) => !!v || '指标名称不能为空']"></v-text-field>
            <v-select v-model="formData.type" :items="zyTypeList" item-text="name" color="#4caf50" item-value="type"
              label="指标类型 *" no-data-text="暂无数据" :rules="[(v) => !!v || '指标类型不能为空']"></v-select>
            <v-text-field v-model="formData.name2" label="指标标签 *" color="#4caf50"
              :rules="[(v) => !!v || '指标标签不能为空']"></v-text-field>
            <div class="dimensional">
              <div class="label-title">
                <div class="text">指标数据维度构成 *</div>
                <div class="c-btn">
                  <v-btn color="primary" small @click="addIllustrate()">添加数据</v-btn>
                </div>
              </div>
              <div class="content">
                <div class="content-title">
                  <div class="index">序号</div>
                  <div class="proportion">数据占比(总和必须为1)</div>
                  <div class="illustrate">构成说明</div>
                </div>
                <div class="content-list" v-for="(item, index) in illustrateList">
                  <div class="text">{{ index }}</div>
                  <div class="num-input">
                    <v-text-field hide-details solo suffix="%" v-model="item.value1" ></v-text-field>
                  </div>
                  <div class="rich-text">
                    <v-textarea
                      hide-details
                      solo
                      label="说明"
                      v-model="item.value2"
                    ></v-textarea>
                  </div>
                  <div class="delete" @click="delIllustrate(index)">
                    <span class="material-icons">delete_forever</span>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="card-padding d-flex justify-end">
            <v-btn elevation="0" :ripple="false" height="35" color="success"
              class="font-weight-normal text-capitalize btn-ls py-3 px-6" :loading="submitLoading" @click="formSubmit">提交申请</v-btn>
            <v-btn elevation="0" :ripple="false" height="35"
              class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
              @click="formClose">取消</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import CommonHeader from '@/components/DataService/CommonHeader.vue';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        value1: '',
        value2: '',
        value3: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      selectMetaListData: [{ text: '行为', value: 1 }, { text: '基本', value: 2 }],
      dateMenu: false,


      tableHeader: [
        {
          text: '序号',
          align: 'start',
          sortable: false,
          value: 'index',
        },
        { text: '指标名称', value: 'name' },
        { text: '指标类型', value: 'type' },
        { text: '指标标签', value: 'tag' },
        { text: '学习力配比', value: 'proportion' },
        { text: '操作', value: 'option' },
      ],
      tableList: [
        {
          index: 1,
          name: '自我驱动力',
          type: 1,
          tag: '学习态度',
          proportion: '20%',
        },
        {
          index: 2,
          name: '信息获取力',
          type: 0,
          tag: '知识掌握',
          proportion: '30%',
        },
        {
          index: 3,
          name: '知识转化力',
          type: 0,
          tag: '知识掌握',
          proportion: '40%',
        },
        {
          index: 4,
          name: '持续学习力',
          type: 2,
          tag: '终生学习',
          proportion: '10%',
        },
      ],
      pagination: {
        page: 1,
        total: 1,
        perPageOptions: [8, 12, 16, 20],
      },

      dialog: false,
      formData: {
        name: "",
        name2: "",
        type: "",
        typeName: "",
        fileName: "",
        size: "",
        accept: "",
        fullPath: "",
        file: "",
      },
      formValid: false,
      submitLoading: false,

      zyTypeList: [
        { name: "行为", type: 0 },
        { name: "能力", type: 1 },
        { name: "态度", type: 2 },
        { name: "知识", type: 3 },
      ],
      illustrateList: [],
      zyTypeDict: {},
    };
  },

  created() {
    this.zyTypeDict = this.zyTypeList.reduce((acc, curr) => {
      acc[curr.type] = curr.name;
      return acc;
    }, {});
  },

  mounted() {

  },

  methods: {
    searchQuery() {
      console.log(123,this.queryParams)
      this.getTableList()
    },
    searchClear() {
      this.queryParams = {
        value1: '',
        value2: '',
        value3: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      }
    },
    // 翻页
    inputChange(e) {
      this.pagination.page = e;
      this.getTableList()
    },
    getTableList() {

    },


    formSubmit() {
      this.$refs.formRef.validate()
      if (this.formValid) {
        this.submitLoading = true
        setTimeout(() => {
          this.submitLoading = false
        }, 1000);
      }
    },
    formClose() {
      this.dialog = false;
      this.$refs.formRef.reset();
      this.$refs.formRef.resetValidation();
    },
    inputDialog(val) {
      if (!val) {
        this.formClose()
      }
    },
    addClick() {
      console.log(1232324)
      this.dialog = true
    },
    addIllustrate() {
      this.illustrateList.push({
        value1: '',
        value2: '',
      })
    },
    delIllustrate(index) {
      this.illustrateList.splice(index, 1)
    },

    goBack() {
      this.$router.push({
        name: 'LearningAbilityData',
      });
    },
  }
}
</script>

<style></style>

<style scoped>
.page-wrapper {
  margin: 0 15px;

  .table-data {
    .v-card {
      padding: 10px;
    }

    .table-header {
      .text-field-width {
        display: inline-block;
        width: 200px;
        margin: 0 5px 5px 0;
      }

      .select-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .date-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .v-btn {
        margin: 5px;
      }
    }

    .table-content {
      padding: 10px 0;
    }

    .table-paging {
      overflow: hidden;
      text-align: right;

      .table-pagination {
        float: right;
      }
    }
  }
}

.dimensional {
  .label-title {
    display: flex;

    .text {
      font-size: 16px;
      margin-right: 15px;
    }
  }

  .content {
    margin-top: 10px;
    .content-title {
      display: flex;
      text-align: center;
      .index {
        text-align: left;
        flex: 1;
      }
      .proportion {
        flex: 2;
      }
      .illustrate {
        flex: 6;
      }
    }
    .content-list {
      display: flex;
      margin-bottom: 10px;
      .text {
        flex: 1;
        text-align: left;
      }
      .num-input {
        flex: 2;
        margin: 0 5px;
      }
      .rich-text {
        flex: 6;
      }
      .delete {
        cursor: pointer;
        height: 100%;
        margin: 0 5px;
      }
    }
  }

}
</style>